<div class="steps-wrapper">
  <div class="steps">
    @for (step of steps; track step; let i = $index) {
      <div class="step">
        <div class="bar" [ngClass]="{enabled: selectedIndex === i}"></div>
        <div class="step-label" [ngClass]="{enabled: selectedIndex === i}">{{step.label}}</div>
      </div>
    }
  </div>
</div>

<gbc-page-container>
  @if (selected) {
    <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
  }

  <footer class="stepper-navigation my-8">
    <button
      gbc-button
      cdkStepperPrevious
      [disabled]="selectedIndex === 0 || backDisabled"
      class="stepper-button stepper-button--back primary"
      data-test-id="stepper-button-back">
      {{ backLabel }}
    </button>

    @if (selectedIndex !== (steps.length - 1)) {
      <button
        gbc-button
        cdkStepperNext
        [disabled]="nextDisabled"
        class="stepper-button primary"
        data-test-id="stepper-button-next">
        {{ nextLabel }}
      </button>
    }

    @if (selectedIndex === (steps.length - 1)) {
      <button
        gbc-button
        class="stepper-button"
        (click)="done.emit()"
        [disabled]="doneDisabled"
        data-test-id="stepper-button-done">
        {{ doneLabel }}
      </button>
    }
  </footer>
</gbc-page-container>
